import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

class LayerNodeDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
      tooltipStyle: {},
    };
    this.textElementRef = React.createRef();
  }

  handleMouseEnter = (event) => {
    const { parent } = this.props;
    const textElement = this.textElementRef.current;
    const rect = event.target.getBoundingClientRect();
    if (parent) {
      if (textElement.scrollWidth > textElement.clientWidth) {
        this.setState({
          showTooltip: true,
          tooltipStyle: {
            position: 'absolute',
            top: `${rect.top + window.scrollY}px`,
            zIndex: '11111111111111',
            marginTop: parent ? 20 : 35,
            left: parent ? `${rect.left + window.scrollX}px` : 200,
          },
        });
      }
    } else {
      this.setState({
        showTooltip: true,
        tooltipStyle: {
          position: 'absolute',
          top: `${rect.top + window.scrollY}px`,
          zIndex: '111111111111111',
          marginTop: parent ? 20 : 35,
          left: parent ? `${rect.left + window.scrollX}px` : 200, // Set left dynamically
        },
      });
    }
  };

  handleMouseLeave = () => {
    this.setState({ showTooltip: false });
  };

  renderTooltip() {
    const { layer, parent } = this.props;
    const { showTooltip, tooltipStyle } = this.state;

    if (!showTooltip) {
      return null;
    }

    return ReactDOM.createPortal(
      <div className="custom-tooltip" style={tooltipStyle}>
        {parent ? this.props.value : layer.description}
      </div>,
      document.body
    );
  }

  render() {
    const { layer, parent, value } = this.props;
    return (
      <div className={parent ? "info-window-header-div" : "layer-node-description"} ref={parent ? this.textElementRef : " "}>
        <span
          className={parent ? "info-window-heading" : "layer-label"}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {parent ? value : layer.description}
        </span>
        {this.renderTooltip()}
      </div>
    );
  }
}

export default LayerNodeDescription;
